import { createSlice } from "@reduxjs/toolkit";
import { SelectedQuestion } from "@src/pages/student/student-assignment-screen/types";

interface InitialState {
  questions: SelectedQuestion[];
  selectedQuestion: SelectedQuestion | null;
}

const initialState: InitialState = {
  questions: [],
  selectedQuestion: null,
};

const assignmentQuestionSlice = createSlice({
  name: "assignmentQuestion",
  initialState: initialState,
  reducers: {
    setQuestions: (state, action) => {
      state.questions = action.payload;
    },
    setSelectedQuestion: (state, action) => {
      state.selectedQuestion = action.payload;
    },
  },
});

export const { setQuestions, setSelectedQuestion } =
  assignmentQuestionSlice.actions;
export default assignmentQuestionSlice.reducer;
